import { connect } from 'react-redux'
import {
  compose, lifecycle, withHandlers, withState,
} from 'recompose'
import { bindActionCreators } from 'redux'
import { updateSiteConfiguration, updateSiteConfigs } from 'actions/Site'
import { fetchAutoDebitPembatalan, exportFile } from 'actions/AutoDebitPembatalan'
import AutoDebitPembatalanView from 'components/pages/autoDebit/pembatalan/List'
import { pickBy, identity } from 'lodash'
import qs from 'query-string'
import { message } from 'antd'
import history from 'utils/history'

export function mapStateToProps(state) {
  const {
    isFetching,
    dataAutoDebitPembatalan,
    metaAutoDebitPembatalan,
  } = state.root.autoDebitPembatalan

  return {
    isFetching,
    dataAutoDebitPembatalan,
    metaAutoDebitPembatalan,
  }
}

const mapDispatchToProps = dispatch => ({
  updateSiteConfiguration: bindActionCreators(updateSiteConfiguration, dispatch),
  updateSiteConfigs: bindActionCreators(updateSiteConfigs, dispatch),
  fetchAutoDebitPembatalan: bindActionCreators(fetchAutoDebitPembatalan, dispatch),
  exportFile: bindActionCreators(exportFile, dispatch),
})

const dataStatus = [
  { id: 1, label: 'Approved', value: 'approved' },
  { id: 2, label: 'In Progress', value: 'in progress' },
  { id: 3, label: 'Inquiry', value: 'inquiry' },
  { id: 4, label: 'Failed', value: 'failed' },
  { id: 5, label: 'Rejected', value: 'rejected' },
]

export default compose(
  connect(
    mapStateToProps,
    mapDispatchToProps,
  ),
  withState('statusList', 'setStatusList', dataStatus),
  withState('dataFile', 'setDataFile', ''),
  withState('paramsFile', 'setParamsFile', ''),
  withState('stateSearch', 'setStateSearch', {}),
  withState('isExport', 'setIsExport', false),
  withHandlers({
    onLoad: props => (isSearch) => {
      const {
        page, search, status, startDate, endDate,
      } = props.stateSearch
      const payload = {
        page: isSearch ? '' : page,
        search: search || '',
        status: status || '',
        start_date: startDate || '',
        end_date: endDate || '',
      }
      props.setParamsFile(`?${qs.stringify(pickBy(payload, identity))}`)
      props.fetchAutoDebitPembatalan(`?${qs.stringify(pickBy(payload, identity))}`)
    },
  }),
  withHandlers({
    handleReport: props => () => {
      const { paramsFile, setIsExport } = props
      setIsExport(true)
      props.exportFile(paramsFile)
        .then((result) => {
          if (result) {
            setIsExport(false)
            history.push('/download')
          } else {
            message.error('Something when wrong')
          }
        }).catch((error) => {
          message.error(error)
          setIsExport(false)
        })
    },
    handleSearch: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        search: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handleChangeStatus: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        status: val,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handleChangeDate: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      let start = ''
      let end = ''
      if (val.length === 2) {
        start = val[0].format('DD-MM-YYYY')
        end = val[1].format('DD-MM-YYYY')
      } else {
        start = ''
        end = ''
      }
      setStateSearch({
        ...stateSearch,
        startDate: start,
        endDate: end,
      })
      setTimeout(() => {
        onLoad(true)
      }, 300)
    },
    handlePage: props => (val) => {
      const { onLoad, setStateSearch, stateSearch } = props
      setStateSearch({
        ...stateSearch,
        page: val,
      })
      setTimeout(() => {
        onLoad()
      }, 300)
    },
  }),
  lifecycle({
    componentDidMount() {
      this.props.updateSiteConfiguration('breadList', ['Home', 'Autodebet', 'Pembatalan', 'List'])
      this.props.updateSiteConfigs({
        titlePage: 'Autodebet - Pembatalan',
        activePage: 'auto-debet/pembatalan',
        activeSubPage: 'pembatalan',
      })
      this.props.fetchAutoDebitPembatalan()
    },
  }),
)(AutoDebitPembatalanView)
